import React from 'react';
import { Tag } from '@/components/ui';
import { isGlobalScheme } from '@/utils/orderSchemeGroup';

interface SchemeLabelProps {
  scheme: { code?: string; name?: string; region?: number | null } | null;
}

/** Scheme code with a "Global" tag, so a row's region is visible where it decides what can be selected. */
const SchemeLabel: React.FC<SchemeLabelProps> = ({ scheme }) => (
  <>
    {scheme?.code ?? scheme?.name ?? '—'}
    {isGlobalScheme(scheme) && <> <Tag>Global</Tag></>}
  </>
);

export default SchemeLabel;
